import Dashboard from "./Dashboard.vue";
import Add from "./Add.vue";
import Edit from "./Edit.vue";
import Schema from './schema';


export default { Dashboard, Add, Edit, Schema };
